import React from 'react';
import styled, {css} from 'styled-components';
import {useFragment, graphql} from 'react-relay';
import {tokensForThemeProvider} from '@forecast-it/design-system';
import {D} from '../ai-chat/design-tokens';
import {PromptRow_savedPrompt$key} from './__generated__/PromptRow_savedPrompt.graphql';
const {font} = tokensForThemeProvider.sky.sys;

const bodyFont = css`
	${font.body['1']}
`;

const PromptRow_savedPromptFragment = graphql`
	fragment PromptRow_savedPrompt on SavedPrompt {
		id
		name
		promptText
	}
`;

const Row = styled.button`
	${bodyFont}
	display: flex;
	align-items: center;
	width: 100%;
	height: 44px;
	padding: 0 16px;
	border: none;
	background: transparent;
	border-radius: 0;
	cursor: pointer;
	text-align: left;
	color: ${D.v2.textPrimary};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	&:hover {
		background: ${D.v2.surfaceHover};
	}
`;

type PromptRowProps = {
	savedPromptRef: PromptRow_savedPrompt$key;
	onSelect: (promptText: string) => void;
};

const PromptRow = ({savedPromptRef, onSelect}: PromptRowProps): JSX.Element => {
	const prompt = useFragment(PromptRow_savedPromptFragment, savedPromptRef);

	return (
		<Row type="button" onClick={() => onSelect(prompt.promptText ?? '')}>
			{prompt.name}
		</Row>
	);
};

export default PromptRow;
